import { withStyles } from 'vopay';
import Chip from '../Chip/Chip';
import styles from './FilterChips.module.scss';

const cn = withStyles(styles);

export type FilterChipOption<T extends string> = { value: T; label: string };

type FilterChipsProps<T extends string> = {
  options: FilterChipOption<T>[];
  value: T;
  onChange: (value: T) => void;
  'aria-label'?: string;
};

export default function FilterChips<T extends string>({
  options,
  value,
  onChange,
  'aria-label': ariaLabel,
}: FilterChipsProps<T>) {
  return (
    <div className={cn('filterChips')} role="group" aria-label={ariaLabel}>
      {options.map((option) => (
        <Chip
          key={option.value}
          size="md"
          label={option.label}
          isActive={option.value === value}
          onClick={() => onChange(option.value)}
        />
      ))}
    </div>
  );
}
